/**
 * @method getPKFromID
 * @param {String} id - graphql id string
 * @returns {Number} pk int
 */
const getPKFromID = (id) => {
  if (!id) {
    return null;
  }

  return parseInt(window.atob(id).split(':')[1]);
};

export default getPKFromID;
